import { useQuery } from '@tanstack/react-query';
import { adminQueries } from '@blimo/api-client';
import { useApi } from '@blimo/api-client/react';

/** Current calendar year (default year of the readings pages). */
export const currentYear = () => new Date().getFullYear();

/** Valid year from the URL (`?year=2026`), otherwise the current year. @param {unknown} value */
export function yearFrom(value) {
  const n = Number(value);
  return Number.isInteger(n) && n >= 2000 && n <= 2100 ? n : currentYear();
}

/** Year options (next year down to six years back), always containing `selected`. @param {number} [selected] */
export function yearOptions(selected) {
  const now = currentYear();
  const years = Array.from({ length: 8 }, (_, i) => now + 1 - i);
  if (selected && !years.includes(selected)) years.push(selected);
  return years.sort((a, b) => b - a).map((y) => ({ value: String(y), label: String(y) }));
}

/** Meter value for an input field ("12345,6"). @param {number|null|undefined} value */
export const toInputValue = (value) => (value === null || value === undefined ? '' : String(value).replace('.', ','));

/** "4711 · Strom" */
export const meterLabel = (meter) => [meter?.number, meter?.type].filter(Boolean).join(' · ') || (meter ? `Zähler #${meter.id}` : '–');

/** Supplier options for selects/filters. */
export function useSupplierOptions() {
  const api = useApi();
  const { data } = useQuery(adminQueries.meterSuppliers(api));
  return (data ?? []).map((s) => ({ value: String(s.id), label: s.name }));
}
